import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './buttons.scss';

const LoadingIcon = () => {
        return (
            <svg viewBox='0 0 128 128'>
                <path
                    fill='#ffffff'
                    fillOpacity='1'
                    d='M109.25 55.5h-36l12-12a29.54 29.54 0 0 0-49.53 12H18.75A46.04 46.04 0 0 1 96.9 31.84l12.35-12.34v36zm-90.5 17h36l-12 12a29.54 29.54 0 0 0 49.53-12h16.97A46.04 46.04 0 0 1 31.1 96.16L18.74 108.5v-36z'
                >
                    <animateTransform
                        attributeType='xml'
                        attributeName='transform'
                        type='rotate'
                        from='0 64 64'
                        to='360 64 64'
                        dur='1250ms'
                        repeatCount='indefinite'
                    />
                </path>
            </svg>
        );
    },

    PrevIcon = () => {
        return (
            <svg viewBox='0 0 9 16'>
                <path
                    d='M1.54890057,7.74450284 L8.90617827,15.1017805 L8.13172798,15.8762308 L0.387225142,8.13172798 L-1.24344979e-14,7.74450284 L7.74450284,3.33066907e-16 L8.51895313,0.774450284 L1.54890057,7.74450284 Z'
                    fill='#5F6570'
                />
            </svg>
        );
    },

    RestartButton = props => {
        const { text, loading, loadingText, disabled, onClick, id, primaryAction, ternaryButton } = props,
            classes = classNames({
                'ht-button': true,
                'ht-button--primary': primaryAction,
                'ht-button--loading': loading,
                'ht-button--disabled': disabled || loading,
                'ht-button--link': !primaryAction,
                'ht-button--ternary': ternaryButton
            });

        return <button
            id={id}
            type='button'
            className={classes}
            disabled={disabled || loading}
            onClick={onClick}
            data-action='restart'
        >
            {loading && (
                <>
                    <LoadingIcon />
                    {loadingText}
                </>
            )}
            {!loading && <>{text}</>}
        </button>;
    },

    NextButton = props => {
        const { text, loading, loadingText, disabled, onClick, id, nextActionName, centered } = props,
            classes = classNames({
                'ht-button': true,
                'ht-button--primary': true,
                'ht-button--loading': loading,
                'ht-button--disabled': disabled || loading,
                'ht-button--centered': centered
            });

        return (
            <button
                id={id}
                type='button'
                className={classes}
                disabled={disabled || loading}
                onClick={onClick}
                data-action={nextActionName}
            >
                {loading && (
                    <>
                        <LoadingIcon />
                        {loadingText}
                    </>
                )}
                {!loading && <>{text}</>}
            </button>
        );
    },

    PrevButton = props => {
        const { text, disabled, onClick, id, prevActionName } = props,
            classes = classNames({
                'ht-button': true,
                'ht-button--prev': true,
                'ht-button--disabled': disabled
            });

        return (
            <button
                id={id}
                type='button'
                className={classes}
                disabled={disabled}
                onClick={onClick}
                data-action={prevActionName}
            >
                <PrevIcon />
                <span>{text}</span>
            </button>
        );
    };

NextButton.defaultProps = {
    text: 'Next Section',
    loading: false,
    loadingText: 'Saving Progress',
    disabled: false,
    onClick: null,
    nextActionName: null
};

NextButton.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string,
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    nextActionName: PropTypes.string
};

RestartButton.defaultProps = {
    text: 'Start Again',
    loading: false,
    loadingText: 'Restarting',
    disabled: false,
    onClick: null,
    primaryAction: false
};

RestartButton.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string,
    primaryAction: PropTypes.bool,
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    ternaryButton: PropTypes.bool
};

PrevButton.defaultProps = {
    text: 'Previous Section',
    disabled: false,
    onClick: null,
    prevActionName: null
};

PrevButton.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    prevActionName: PropTypes.string
};

export { NextButton, PrevButton, RestartButton };
